var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.16137 13.0264L0.706959 17.026C0.42112 17.8121 1.16914 18.5808 1.96271 18.3165L6.47296 16.8145C6.62035 16.7654 6.75427 16.6827 6.86411 16.5729L17.3008 6.13617C18.0917 5.34522 18.0653 4.49589 17.9197 4.0536C17.8861 3.95164 17.8202 3.8651 17.7443 3.78916L15.1833 1.22619C15.1072 1.15007 15.0205 1.08271 14.9178 1.05062C14.031 0.773558 12.8055 1.69994 12.278 2.22744L2.37522 12.6804C2.28098 12.7798 2.2082 12.8976 2.16137 13.0264Z",
    stroke: "#7C8092"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.2323 12.8359L6.13893 16.7426",
    stroke: "#7C8092"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.278 2.78906L16.1846 6.69569",
    stroke: "#7C8092"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPen);
export default __webpack_public_path__ + "static/media/edit-pen.bf0c30738e9bc7f55ec1b1ee13e1d034.svg";
export { ForwardRef as ReactComponent };